module.exports = __webpack_public_path__ + "img/olharDigital.11719492.webp";